import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert,
  TextField, Box, Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import GovernmentInvoice from '../../models/governmentInvoice';

/** Cancel a signed HDDT invoice (irreversible at the tax authority) — requires a reason. */
const HddtCancelDialog = ({ open, onClose, governmentInvoice, onDone }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => { setReason(''); onClose(); };

  const submit = async () => {
    setSubmitting(true);
    try {
      const gi = new GovernmentInvoice(governmentInvoice);
      const result = await gi.cancel(reason);
      if (result) {
        toast.success('Đã hủy hóa đơn điện tử');
        if (onDone) onDone(result);
        handleClose();
      } else {
        toast.error('Không thể hủy hóa đơn điện tử');
      }
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Lỗi khi hủy hóa đơn');
    } finally { setSubmitting(false); }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Hủy hóa đơn điện tử {governmentInvoice?.hddt_sh_don || ''}</DialogTitle>
      <DialogContent dividers>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Bạn đang hủy hóa đơn đã phát hành. Thao tác này không thể hoàn tác trên hệ thống thuế.
        </Alert>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2">Mẫu: {governmentInvoice?.hddt_khmsh_don}/{governmentInvoice?.hddt_khh_don}</Typography>
          <Typography variant="body2">Người mua: {governmentInvoice?.hddt_buyer_name}</Typography>
          <Typography variant="body2">Tổng tiền: {(governmentInvoice?.hddt_total_amount || 0).toLocaleString('vi-VN')} đ</Typography>
        </Box>
        <TextField label="Lý do hủy (*)" value={reason} onChange={(e) => setReason(e.target.value)}
          multiline rows={2} fullWidth required />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>Quay lại</Button>
        <Button onClick={submit} variant="contained" color="error"
          disabled={!reason.trim() || submitting}>
          {submitting ? 'Đang hủy...' : 'Xác nhận hủy'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HddtCancelDialog;
